export class FolderNode {
    constructor(dirName, dirParent){
      this.dirName = dirName;
      this.dirParent = dirParent;
      this.subfolders = [];
  }
}